var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 60,
    cy: 60,
    r: 59
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(26.000000, 40.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: -1,
    y: -1,
    width: 70.5203575,
    height: 41.4736842
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    strokeLinejoin: "round",
    points: "3.78734407 35.6569515 14.8487554 25.1584203 19.8548336 29.9097551 46.8630813 4.27587149 64.0852587 20.6216668 64.0852587 35.6569515"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 15.0744786,
    cy: 13.1578947,
    rx: 4.11122145,
    ry: 3.94736842
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPictureIcon);
export default __webpack_public_path__ + "static/media/noPictureIcon.7e7dc26cee4cf6768542d6a0c64f41d7.svg";
export { ForwardRef as ReactComponent };